import React, { useContext } from "react";
import { ConversationContext } from "./Conversation";
import "./Headings/headings.css"; 

export const Radio = () => {
  const { options, value, setValue, id, next } =
    useContext(ConversationContext);
  return (
    <div className="grid justify-items-center">
      {options.map((option) => {
        return (
          <button
            disabled={!!value}
            key={option?.value}
            className={`mb-3 p-2 rounded-xl lg:w-3/5 w-4/5 ${
              value === option.value
                ? " bg-colorWhite border-2 border-colorSecondary"
                : "border-2 border-colorSecondary bg-colorWhite"
            }`}
            onClick={(e) => {
              // console.log("option.next => ", option?.next);
              // if (e.target.innerText === value) {
              //   return setValue(id, "", true, option?.next || next);
              // }
              setValue(
                id,
                e.target.innerText,
                true,
                option?.next || next,
                "radio",
                option.key
              );
            }}
          >
            {option?.value || option}
          </button>
        );
      })}
      {value ? <div className="answerArrow"></div> : ""}
    </div>
  );
};
